const SID_KEY = "eg_sid";
const API = process.env.REACT_APP_BACKEND_URL;

function sid() {
  let s = localStorage.getItem(SID_KEY);
  if (!s) {
    s = (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random();
    localStorage.setItem(SID_KEY, s);
  }
  return s;
}

function send(type, extra = {}) {
  try {
    const body = JSON.stringify({ type, path: window.location.pathname, session_id: sid(), referrer: document.referrer || "", ...extra });
    const url = `${API}/api/track`;
    if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    else fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
  } catch (e) { /* ignore */ }
}

let enterTs = Date.now();

export function trackPageview() { enterTs = Date.now(); send("pageview"); }

export function trackDwell() {
  const s = Math.round((Date.now() - enterTs) / 1000);
  if (s > 0 && s < 3600) send("dwell", { seconds: s });
}

export function initClickTracking() {
  if (window.__egClick) return;
  window.__egClick = true;
  document.addEventListener("click", (e) => {
    const el = e.target.closest("a,button,[data-track]");
    if (!el) return;
    const label = (el.getAttribute("data-track") || el.innerText || el.getAttribute("aria-label") || el.tagName || "").trim().slice(0, 80);
    if (label) send("click", { target: `${window.location.pathname} · ${label}` });
  }, true);
}
